import React, { useState } from 'react'
import './expanded-schedule-view.scss'
import classnames from 'classnames'
import cronstrue from 'cronstrue'
import { parseExpression } from 'cron-parser'
import { Descriptions, Radio } from 'antd'
import { IExpandedJobView } from './interfaces'
import JsonView from '@halo/components/json-view/json-view'
import { Well } from '@pushly/aqe/lib/components'
import { fmtDateString } from '@halo/helpers/formatting'
import { observer } from 'mobx-react'
import { useService } from '@halo/hooks/use-service'
import { AppState } from '@halo/stores/app.state'
import { useUserPreferences } from '@pushly/aqe/lib/providers/user-preferences-provider/core/index'

const CronIterationsView = observer(({ cron, iterations }: any) => {
    const appState = useService<AppState>(AppState)
    const userPreferences = useUserPreferences(appState.currentUser.id)
    const local = userPreferences.get(['display_time_zone']) !== 'UTC'
    const cronIterations: any[] = []

    try {
        const cronExpr = !cron ? undefined : parseExpression(cron, {})
        if (!!cronExpr) {
            new Array(iterations ?? 5).fill(0).forEach(() => {
                cronIterations.push(cronExpr.next())
            })
        }
    } catch (_) {
        console.warn('CRON ERR', _)
    }

    return (
        <span className="next-occurrences">
            {cronIterations.map((iter, idx) => {
                const iterStrUtc = fmtDateString(iter.toString(), 'LLLL [UTC]')

                return (
                    <span key={idx} className="occurrence">
                        {local !== true ? iterStrUtc : fmtDateString(iterStrUtc, 'LLLL z', 'America/Chicago')}
                    </span>
                )
            })}
        </span>
    )
})

const ExpandedScheduleView = ({ schedule, index, expanded, indent }: IExpandedJobView) => {
    const { type, name, ...targetConfig } = schedule.target ?? {}
    const isExtendedCron = schedule.schedule.split(' ').length === 6
    let cronStr = schedule.schedule.replace(/\?/g, '*')
    if (isExtendedCron) {
        cronStr = cronStr.replace(/ \*$/, '')
    }

    return (
        <div className={classnames('expanded-schedule-view')}>
            <Well title="Schedule Details" hideFooter={true}>
                <Descriptions layout="horizontal" column={1}>
                    <Descriptions.Item label="Name">
                        <span>{schedule.name}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Target">
                        <span className="target-type">[{type}] </span>
                        <span className="target-name">{name}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Environments">
                        <span>{schedule.prod_only ? 'Production' : 'All'}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Enabled">
                        <span>{schedule.enabled ? 'TRUE' : 'FALSE'}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label="Schedule">
                        <span className="cron-value">{cronStr}</span>
                        <span className="cron-label">
                            {cronstrue.toString(cronStr, { dayOfWeekStartIndexZero: true })}
                        </span>
                    </Descriptions.Item>
                    <Descriptions.Item className="iter-label" label="Next 5">
                        <CronIterationsView cron={cronStr} />
                    </Descriptions.Item>

                    <Descriptions.Item label="Target Config">
                        <JsonView data={schedule.target} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Alarm Config">
                        <JsonView data={schedule.alarm_config ?? null} />
                    </Descriptions.Item>
                    <Descriptions.Item label="Payload">
                        <JsonView data={schedule.payload ?? null} />
                    </Descriptions.Item>
                </Descriptions>
            </Well>
        </div>
    )
}

export default ExpandedScheduleView
